import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';

export const ImageWrapper = styled('div')`
    display: flex;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background: ${COLORS.neutral_50};
    overflow: hidden;
`;

export const Image = styled('img')`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
`;
